<template lang="pug">
.rent-object-features-wrapper
  .button-flex
    .button-wrapper  
      b-button(type="is-light" icon-left="pencil" @click="openModal()") Ausstattung bearbeiten
      .spacer.md
    CopyPasteModal(:id="id" :rentObjectType="rentObjectType" destination="Ausstattung" @copySuccess="reloadData()")
  
  //- .card
    .main.padding
      b-taglist.margin-top
        b-tag(v-for="tag in tags" type="is-dark" size="is-medium") {{tag.featureTag.name}}

  template(v-for="category, idx in tags")
    .card.margin-top
      .top.between
        .left
          .card-headline {{category.name}}
        .right
          b-button(type="is-light" icon-left="pencil" @click="openRenameCategoryModal(category.name, idx)")
          .spacer.sm.inline
          b-button(type="is-light" icon-left="arrow-up" @click="moveUpCategory(idx)")
          .spacer.sm.inline
          b-button(type="is-light" icon-left="arrow-down" @click="moveDownCategory(idx)")
      .main.padding
        draggable(:list="tags[idx].tags" group="features")
          .f-tag(v-for="tag in category.tags" :key="category.name+'-'+tag.id") {{tag.featureTag.name}}
    b-button(type="is-text" icon-left="plus" @click="openCategoryModal(idx + 1)") Kategorie hinzufügen

  .button-wrapper.margin-top.right
    b-button(type="is-primary" @click="saveTagsWithCategoryAndPosition()") Speichern
  //- .card.margin-top
    .top
      .left
        h2.subtitle Allgemein
        b-taglist.margin-top
          draggable(:list="tags" group="people")
            transition-group(type="transition" name="flip-list")
              b-tag(v-for="tag in tags" type="is-dark" size="is-medium" :key="tag.id") {{tag.featureTag.name}}
  b-modal(
    v-model="isCategoryActive"
    has-modal-card
    :full-screen="false" 
    :can-cancel="true"
    )
    .modal-card(style="width: auto")  
      header.modal-card-head
        p.modal-card-title Neue Kategory
      section.modal-card-body
        b-field(label="Bezeichnung")
          b-input(v-model="activeCategory.name")
        .button-wrapper.right
          b-button(type="is-primary" @click="saveCategory()") Speichern
  
  b-modal(
    v-model="isRenameCategoryActive"
    has-modal-card
    :full-screen="false" 
    :can-cancel="true"
    )
    .modal-card(style="width: auto")  
      header.modal-card-head
        p.modal-card-title Kategory umbennenen
      section.modal-card-body
        b-field(label="Bezeichnung")
          b-input(v-model="activeCategory.name")
        .button-wrapper.right
          b-button(type="is-primary" @click="renameCategory()") Speichern

  b-modal(
    v-model="isModalActive"
    has-modal-card
    :full-screen="false" 
    :can-cancel="true"
    )
    .modal-card(style="width: auto")  
      header.modal-card-head
        p.modal-card-title Ausstattungen bearbeiten
      section.modal-card-body
        b-table(:data="featureTags"
                default-sort-direction="asc"
                default-sort="name"
                :checked-rows.sync="checkedRows"
                checkable
                hoverable)
          b-table-column(field='name' label='Name' sortable, v-slot="props")
            | {{ props.row.name }}
          b-table-column(field='internalDescription' label='Interne Beschreibung' v-slot="props")
            | {{ props.row.internalDescription }}
          b-table-column(field='externalDescription' label='Externe Beschreibung' v-slot="props")
            | {{ props.row.externalDescription }}

      footer.modal-card-foot
        b-button(type="is-light" @click="isModalActive = false") Abbrechen
        b-button(type="is-primary" @click="saveTags()") Speichern

</template>

<script>
import CopyPasteModal from "@/components/molecules/CopyPasteModal.vue";
import draggable from 'vuedraggable';

export default {
  components: {
    draggable,
    CopyPasteModal
  },
  props: {
    id: {
      type: [Number, String],
      default: null
    },
    rentObjectType: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      checkedRows: [],
      isModalActive: false,
      isCategoryActive: false,
      isRenameCategoryActive: false,
      activeCategory: {
        pos: null,
        name: null
      },
      tags: [],
      filterText: "",
      list1: [
        { name: "John", id: 1 },
        { name: "Joao", id: 2 },
        { name: "Jean", id: 3 },
        { name: "Gerard", id: 4 }
      ],
      list2: [
        { name: "Juan", id: 5 },
        { name: "Edgard", id: 6 },
        { name: "Johnson", id: 7 }
      ]
    };
  },
  computed: {
    rentObjectFeatureTags() {
      return this.$store.state.rentObjectFeatureTags.all;
    },
    featureTags() {
      return this.$store.state.featureTags.all;
    }
  },
  methods: {
    openModal() {
      this.isModalActive = true;
    },
    openCategoryModal(pos) {
      this.activeCategory.pos = pos;
      this.activeCategory.name = '';
      this.isCategoryActive = true;
    },
    openRenameCategoryModal(name, pos) {
      this.activeCategory.pos = pos;
      this.activeCategory.name = name;
      this.isRenameCategoryActive = true;
    },
    saveCategory() {
      this.tags.splice(this.activeCategory.pos, 0, { name: this.activeCategory.name, tags: [] });
      this.isCategoryActive = false;
    },
    renameCategory() {
      this.tags[this.activeCategory.pos].name = this.activeCategory.name;
      this.isRenameCategoryActive = false;
    },
    moveUpCategory(idx) {
      if (idx === 0) return;
      const temp = this.tags[idx];
      this.$set(this.tags, idx, this.tags[idx - 1]);
      this.$set(this.tags, idx - 1, temp);
    },
    moveDownCategory(idx) {
      if (idx === this.tags.length - 1) return;
      const temp = this.tags[idx];
      this.$set(this.tags, idx, this.tags[idx + 1]);
      this.$set(this.tags, idx + 1, temp);
    },
    async saveTags() {
      await this.$store.dispatch("rentObjectFeatureTags/create", {
        id: this.id,
        featureTags: this.checkedRows.map(c => ({...c, rentObjectFeatureTags: null}))
      });
      await this.$store.dispatch("rentObjectFeatureTags/findAll", {
          id: this.id
        });
      this.tags = JSON.parse(
        JSON.stringify(this.$store.state.rentObjectFeatureTags.all)
      );
      this.tags = this.createCategories(this.tags);
      this.isModalActive = false;
    },
    async saveTagsWithCategoryAndPosition() {
      const featureTags = [];
      let masterPos = 0;
      for (let cIdx = 0; cIdx < this.tags.length; cIdx += 1) {
        const category = this.tags[cIdx];
        for (let tIdx = 0; tIdx < category.tags.length; tIdx += 1) {
          const tag = this.tags[cIdx].tags[tIdx];
          tag.category = category.name;
          tag.position = masterPos;
          featureTags.push(tag);
          masterPos += 1;
        }
      }
      await this.$store.dispatch("rentObjectFeatureTags/update", {
        id: this.id,
        featureTags
      });
      this.reloadData();
    },
    async deleteTag(e) {
      if (e.rentObjectFeatureTagId) {
        await this.$store.dispatch("rentObjectFeatureTags/delete", {
          id: e.rentObjectFeatureTagId
        });
        await this.$store.dispatch("rentObjectFeatureTags/findAll", {
          id: this.id
        });
        this.tags = JSON.parse(
          JSON.stringify(this.$store.state.rentObjectFeatureTags.all)
        );
        this.tags = this.createCategories(this.tags);
      }
    },
    async reloadData() {
      this.checkedRows = [];
      await this.$store.dispatch("featureTags/findAll");
      await this.$store.dispatch("rentObjectFeatureTags/findAll", {
        id: this.id
      });
      this.tags = JSON.parse(
        JSON.stringify(this.$store.state.rentObjectFeatureTags.all)
      );
      this.tags.forEach(element => {
        const d = this.featureTags.find(f => f.id === element.featureTag.id);
        this.checkedRows.push(d);
      });
      this.tags = this.createCategories(this.tags);
    },
    createCategories(tags) {
      // Important!
      // We assume that the list is ordered from the server
      let categories = [];

      for (let i = 0; i < tags.length; i += 1) {
        const tag = tags[i];
        if (tag.category === null) {
          // We check if available
          let category = categories.find(c => c.name === 'Allgemein');
          if (!category) categories.push({name: 'Allgemein', tags: []});
          category = categories.find(c => c.name === 'Allgemein');
          category.tags.push(tag);
        } else {
          // We check if available
          let category = categories.find(c => c.name === tag.category);
          if (!category) categories.push({name: tag.category, tags: []});
          category = categories.find(c => c.name === tag.category);
          category.tags.push(tag);
          
        }
      }
      return categories;
    },
  },
  async mounted() {
   this.reloadData();
  }
};
</script>

<style lang="scss" scoped>
.flip-list-enter {
  transition: transform 0.5s;
}
.f-tag {
  color: black;
  display: inline-block;
  padding: $xs-space $sm-space;
  margin: $xs-space;
  background-color: rgba($secondary, 0.24);
  border-radius: 4px;
  cursor: pointer;
  transition: all 200ms ease;
  &:hover {
    box-shadow: $shadow-lg;
  }
}
</style>